import { useMutation, useQuery } from "@apollo/client";
import React, { useState, useContext, useEffect } from "react";
import Filter from "./components/Filter";
import beneficiary from "../../gql/beneficiary";

import PatientImportJobs from "./components/PatientImportJobs";

import AddBeneficiaryModal from "./components/AddBeneficiaryModal";
import ConformationModal from "../../components/ConformationModal";
// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import { appContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/Pagination";
import DownloadExcel from "../../components/DownloadExcel";
import FilterModal from "./components/modals/FilterModal";


import "./styles/BeneficiaryList.css";
import BeneficiaryDetailModal from "./components/BeneficiaryDetailModal";
import AppModal from "../../components/AppModal";
import { BsGenderMale, BsGenderFemale } from "react-icons/bs";

import { FaDownload, FaFilter, FaGenderless, FaUpload } from "react-icons/fa";
import { IconButton, Tooltip, Dialog } from "@mui/material";

import { TbEditCircle } from "react-icons/tb";
import { MdOutlineFileUpload, MdOutlineRemoveRedEye } from "react-icons/md";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";

import TableLoader from "../../common/TableLoader";
import AppLoader from "../../components/AppLoader";
import CustomButton from "../../shared/CustomButton";
import TableSkeletonLoader from "../../common/TableLoading";
import AppButton from "../../shared/AppButton";
import AppTable from "../../shared/AppTable";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import SearchIcon from "@mui/icons-material/Search";
import { getPatientHealthID } from "../NHIC/nhicApi";
import { API_BASE_URL } from "../../config/apiConfig";

function BeneficiaryList(props) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedDetailID, setSelectedDetailID] = useState(null);
  const [openExcelFileUploadModal, setOpenExcelFileUploadModal] =
    useState(false);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [excelData, setExcelData] = useState([
    { id: 1, name: "John Doe", email: "john.doe@example.com" },
    { id: 2, name: "Jane Doe", email: "jane.doe@example.com" },
    { id: 3, name: "Bob Smith", email: "bob.smith@example.com" },
  ]);
  const { permissions } = useContext(appContext);
  const [item, setItem] = useState({
    id: 11,
    document_id: 22,
    firsr_name: "zain",
    middle_name: "khan",
    full_name: "zain khan",
    family_name: "Royal",
    beneficiary_file_id: "11",
    dob: "2000",
    eHealth_id: "2030",
    nationality: "Pak",
    residency_type: "93",
    document_type: "344",
    contact_number: "432",
    martial_status: "salman",
    gender: "salman45",
    blood_group: "a",
    preferred_language: "234",
    emergency_number: "34",
    email: "3030",
    address_line: "",
    street_line: "34",
    city: "93",
    state: "344",
    country: "432",
    postal_code: "34",
    nphies_id: "93",
    providers_id: "344",
    is_new_born: true,
  });

  const [showDetails, setShowDetails] = useState(false);

  const [showFilters, setShowFilters] = useState(true);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [healthLookupOpen, setHealthLookupOpen] = useState(false);
  const [healthLookupPatient, setHealthLookupPatient] = useState(null);
  const [healthLookupResult, setHealthLookupResult] = useState(null);
  const [healthLookupLoading, setHealthLookupLoading] = useState(false);
  const [currentItem, setCurrentItem] = useState({
    _id: 0,
    Address: "a",
    IqamaExpiry: "arbi@gmail.com",
    StartDate: "name",
    Department: "salman45",
    Gender: "2345",
    StatusId: 1,
  });

  const [limit, setLimit] = useState(15);
  const [pageNo, setPageNo] = useState(
    +JSON?.parse(localStorage?.getItem("beneficiariesPageNo"))
      ? +JSON?.parse(localStorage?.getItem("beneficiariesPageNo"))
      : 1,
  );

  const {
    loading: excelDataLoading,
    error: excelDataError,
    data: excelDataResponse,
    refetch: refetchExcelDataResponse,
  } = useQuery(beneficiary.GET_PATIENTS_IN_EXCEL, {
    variables: { filters: { limit: limit, page: pageNo } },
    skip: true,
  });

  useEffect(() => {
    if (excelDataResponse) {
      setExcelData(JSON.parse(excelDataResponse?.listPatientsExcel?.data));
    }
  }, [excelDataResponse]);

  const [delEntry, {}] = useMutation(beneficiary.DEL_BENEFICIARY, {
    update(proxy, result) {
      onSuccessfulRequestResponse(result.data);
    },
    onError(error) {
      onResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulRequestResponse = (data) => {
    if (data.deletePatient) {
      toast.success("Successfully Deleted!");
      refetch();
    } else {
    }
  };

  const onResponseError = (error) => {
    toast.error(`${error.message}`);
  };

  const { loading, error, data, refetch } = useQuery(
    beneficiary.GET_ALL_PATIENTS,
    {
      variables: { filters: { limit: limit, page: pageNo } },
    },
  );

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message);
    }
  }, [error]);

  const onPageChange = (currentPage) => {
    setPageNo(currentPage);
    refetch({ filters: { limit: limit, page: currentPage } });
    // refetchExcelDataResponse({ filters: { limit: limit, page: currentPage } });
  };

  // if (error) return <p>Error: {error.message}</p>;

  const onClickDelete = (item) => {
    setCurrentItem(item);
    setShowDeleteAlert(true);
  };

  const deleteEntry = () => {
    delEntry({ variables: { input: { ID: currentItem._id } } });
    setShowDeleteAlert(false);
  };

  const onClickEdit = (el) => {
    navigate("/beneficiary/edit/form", { state: { item: el } });
    // setCurrentItem(el);
    // setShowEditModal(true);
  };

  const tableHeaders = [
    { name: t("SQ #") },
    { name: t("Full Name") },
    { name: t("File No") },
    { name: t("Document Type") },
    { name: t("Document") },
    { name: t("Contact No") },
    { name: t("Age") },
    { name: t("Actions") },
  ];

  const documentTypes = [
    { id: "VP", name: t("VISA") },
    { id: "PPN", name: t("Passport") },
    { id: "PRC", name: t("Permanent Resident Card Number") },
    { id: "MR", name: t("Medical record number") },
    { id: "NI", name: t("National Card") },
  ];

  const handleViewClick = (el) => {
    setItem(el);
    setShowDetails(true);
    navigate("/beneficiary/details", { state: { item: el } });
  };

  const handleHealthLookupOpen = (patient) => {
    setHealthLookupPatient(patient);
    setHealthLookupResult(null);
    setHealthLookupOpen(true);
  };

  const handleHealthLookupClose = () => {
    setHealthLookupOpen(false);
    setHealthLookupPatient(null);
    setHealthLookupResult(null);
  };

  const handlePatientHealthIDLookup = async () => {
    if (!healthLookupPatient?.document_id || !healthLookupPatient?.dob) {
      toast.error(t("Document ID and Date of Birth are required"));
      return;
    }

    try {
      setHealthLookupLoading(true);
      const response = await getPatientHealthID(
        healthLookupPatient.document_id,
        healthLookupPatient.dob,
      );
      const result = response?.data || response;
      setHealthLookupResult(result);
      toast.success(
        response?.message || t("Patient health ID retrieved successfully!"),
      );
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          error.message ||
          t("An error occurred while fetching patient health ID"),
      );
      setHealthLookupResult(null);
    } finally {
      setHealthLookupLoading(false);
    }
  };

  function calculateAge(dateOfBirth) {
    // Parse the date of birth string into a Date object
    const dob = new Date(dateOfBirth);

    // Get the current date
    const currentDate = new Date();

    // Calculate the difference in years
    const age = currentDate.getFullYear() - dob.getFullYear();

    // Check if the birthday has occurred this year
    if (
      currentDate.getMonth() < dob.getMonth() ||
      (currentDate.getMonth() === dob.getMonth() &&
        currentDate.getDate() < dob.getDate())
    ) {
      // If not, subtract 1 from the age
      return age - 1;
    }

    // Otherwise, return the calculated age
    return age;
  }

  const downloadExcelFile = (fileName) => {
    refetchExcelDataResponse({ filters: { limit: limit, page: pageNo } }).then(
      (res) => {
        const data = JSON.parse(res?.data?.listPatientsExcel?.data);
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const fileData = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(fileData, `${fileName}.xlsx`);
      },
    );
  };

  const downloadCreateBeneficiaryExcelFile = async () => {
    try {
      const token = localStorage.getItem("token");
      const tokenWithoutQuotes = token.replace(/"/g, "");
      const response = await fetch(
        `${API_BASE_URL}/downloadExcel`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenWithoutQuotes}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const blob = await response.blob();
      const contentDisposition = response.headers.get("Content-Disposition");

      let filename = "beneficiary.xlsx";

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
          if (!filename.endsWith(".xlsx")) {
            filename += ".xlsx";
          }
        }
      }
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error(t("Error downloading the file:"), error);
    }
  };

  const columns = [
    // {
    //   header: t("SQ #"),
    //   render: (row, index) => pageNo * limit + index + 1 - limit,
    // },
    {
      header: t("Full Name"),
      field: "full_name",
      render: (row) => (
        <span className="capitalize font-medium">{row.full_name}</span>
      ),
    },
    { header: t("File No"), field: "file_no" },
    {
      header: t("Document Type"),
      render: (row) => (
        <span>
          {documentTypes.find((d) => d.id === row.document_type)?.name ||
            row.document_type}
        </span>
      ),
    },
    { header: t("Document"), field: "document_id" },
    { header: t("Contact No"), field: "contact_number" },
    {
      header: t("Age"),
      align: "center",
      render: (row) => (
        <div className="flex items-center gap-2 justify-center">
          {calculateAge(row.dob)}
          {row.gender === "male" ? (
            <BsGenderMale className="text-blue-500" />
          ) : (
            <BsGenderFemale className="text-pink-500" />
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="superGit_container !p-0">
        <div className="flex justify-between items-start flex-col md:flex-row gap-2 mb-2">
          <div className="w-full sm:w-[calc(100%-150px)]">
            {/* <Tooltip
              placement="right"
              title={t("Beneficiary List")}
              className="my-auto !mt-2"
            > */}
              <span className="font-semibold text-black/70 text-lg ">
                {t("BENEFICIARIES")}
                <span className=" text-lg ml-1">
                  ({data?.listPatients?.total || 0}{" "}
                  <span className="text-xs font-bold italic">
                    {t("Entries")}
                  </span>
                  )
                </span>
              </span>
            {/* </Tooltip> */}
          </div>
          <div className="w-full flex gap-1.5 flex-col md:flex-row justify-end">
            <AppButton
              label={t("Download")}
              variant="outlined"
              onClick={() => downloadExcelFile("Beneficiaries")}
              startIcon={<FileDownloadOutlinedIcon />}
              className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
            />
            <AppButton
              label={t("download_sample")}
              variant="outlined"
              onClick={downloadCreateBeneficiaryExcelFile}
              startIcon={<FileDownloadOutlinedIcon />}
              className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
            />
            <AppButton
              label={t("upload_excel")}
              variant="outlined"
              startIcon={<MdOutlineFileUpload />}
              onClick={() => setOpenExcelFileUploadModal(true)}
              className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
            />
            <AppButton
              label={t("Import Jobs")}
              variant="outlined"
              onClick={() => setOpenExcelFileUploadModal(true)}
            />
            <AppButton
              label={t("Create Beneficiary")}
              startIcon={<AddIcon />}
              onClick={() => navigate("/beneficiary/form")}
            />
          </div>
        </div>

        {showFilters && (
          <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
            <FilterModal
              refetch={refetch}
              setPageNo={setPageNo}
              setLimit={setLimit}
              pageNo={pageNo}
              setIsLoading={setIsLoading}
            />
          </div>
        )}
        <AppTable
          columns={columns}
          data={data?.listPatients?.data}
          loading={loading || isLoading}
          onView={handleViewClick}
          // onView={(el) => {
          //   handleClickOpen();
          //   setSelectedDetailID(el.id);
          // }}
          onEdit={onClickEdit}
          customActions={[
            {
              title: "Patient Health ID Lookup",
              icon: <PersonSearchIcon sx={{ fontSize: 19 }} />,
              onClick: handleHealthLookupOpen,
            },
          ]}
          LoaderComponent={<TableSkeletonLoader columnCount={7} rowCount={8} />}
        />

        <div>
          <Pagination
            currentPage={pageNo}
            totalPages={data?.listPatients?.pages}
            onPageChange={onPageChange}
          />
        </div>
        <AddBeneficiaryModal
          item={currentItem}
          showBeneficiaryModal={showEditModal}
          setShowBeneficiaryModal={setShowEditModal}
          refetch={refetch}
        />
        <ConformationModal
          open={showDeleteAlert}
          setOpen={setShowDeleteAlert}
          onDelete={deleteEntry}
        />

        <BeneficiaryDetailModal
          open={open}
          setOpen={setOpen}
          handleClose={handleClose}
          handleClickOpen={handleClickOpen}
          selectedDetailID={selectedDetailID}
          setSelectedDetailID={setSelectedDetailID}
        />
        <PatientImportJobs
          open={openExcelFileUploadModal}
          onClose={() => {
            setOpenExcelFileUploadModal(false);
            refetch();
          }}
        />
        <AppModal
          open={healthLookupOpen}
          onClose={handleHealthLookupClose}
          title={t("Patient Health ID Lookup")}
          maxWidth="sm"
          contentSx={{ backgroundColor: "#f8fafc" }}
          disableBackdropClose
        >
          <div className="space-y-4">
            <div className="border-b border-slate-200 pb-4">
              <p className="mb-3 text-[14px] font-bold text-slate-800">
                {healthLookupPatient?.full_name || t("Patient")}
              </p>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <div>
                  <label className="mb-1 block text-[11px] font-bold uppercase text-slate-500">
                    {t("Document ID")}
                  </label>
                  <input
                    value={healthLookupPatient?.document_id || ""}
                    readOnly
                    className="h-9 w-full rounded border border-slate-200 bg-white px-2.5 text-[12px] font-semibold text-slate-700 outline-none"
                  />
                </div>
                <div>
                  <label className="mb-1 block text-[11px] font-bold uppercase text-slate-500">
                    {t("Date of Birth")}
                  </label>
                  <input
                    value={healthLookupPatient?.dob || ""}
                    readOnly
                    className="h-9 w-full rounded border border-slate-200 bg-white px-2.5 text-[12px] font-semibold text-slate-700 outline-none"
                  />
                </div>
              </div>
            </div>

            {healthLookupResult && (
              <div className="border-b border-[#0070C2]/20 pb-4">
                <p className="text-[11px] font-bold uppercase text-slate-500">
                  {t("Health ID")}
                </p>
                <p className="mt-1 break-words text-[20px] font-bold text-[#0070C2]">
                  {healthLookupResult.health_id || "---"}
                </p>
              </div>
            )}

            <div className="flex justify-end gap-2">
              <AppButton
                label={t("Close")}
                variant="outlined"
                onClick={handleHealthLookupClose}
                className="!border-gray-300 !text-gray-600 hover:!bg-gray-100"
                disabled={healthLookupLoading}
              />
              <AppButton
                label={t("Lookup Health ID")}
                onClick={handlePatientHealthIDLookup}
                startIcon={<SearchIcon />}
                isLoading={healthLookupLoading}
                loadingText={t("Searching")}
              />
            </div>
          </div>
        </AppModal>
      </div>
    </>
  );
}

export default BeneficiaryList;
